import { render, staticRenderFns } from "./CustomersGeneralFilter.vue?vue&type=template&id=4dedf6ac&scoped=true&"
import script from "./CustomersGeneralFilter.vue?vue&type=script&lang=js&"
export * from "./CustomersGeneralFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomersGeneralFilter.vue?vue&type=style&index=0&id=4dedf6ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dedf6ac",
  null
  
)

export default component.exports